module.exports = __webpack_public_path__ + "static/img/mail.4fd6bace.svg";